/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadWaitlistDetails
 */
export interface LeadWaitlistDetails {
    /**
     * 
     */
    status_set_date?: string;
    /**
     * 
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the LeadWaitlistDetails interface.
 */
export function instanceOfLeadWaitlistDetails(value: object): value is LeadWaitlistDetails {
    return true;
}

export function LeadWaitlistDetailsFromJSON(json: any): LeadWaitlistDetails {
    return LeadWaitlistDetailsFromJSONTyped(json, false);
}

export function LeadWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWaitlistDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'status_set_date': json['status_set_date'] == null ? undefined : json['status_set_date'],
        'status_set_reason': json['status_set_reason'] == null ? undefined : json['status_set_reason'],
    };
}

export function LeadWaitlistDetailsToJSON(json: any): LeadWaitlistDetails {
    return LeadWaitlistDetailsToJSONTyped(json, false);
}

export function LeadWaitlistDetailsToJSONTyped(value?: LeadWaitlistDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_set_date': value['status_set_date'],
        'status_set_reason': value['status_set_reason'],
    };
}

